import React from 'react';

import { PageSection, PageSectionProps } from './PageSection';
import { UnorderedList } from './UnorderedList';
import { Grid } from './Grid';

export interface CirclePageSectionProps extends PageSectionProps {
    children: React.ReactNode;
}

export const CirclePageSection: React.FC<CirclePageSectionProps> = ({ children, ...props }) => {
    return (
        <PageSection
            {...props}
            css={{
                flex: '1',
                width: '100%',
            }}
        >
            {children}
        </PageSection>
    );
};

export const CircleGrid: React.FC = ({ children }) => {
    return (
        <Grid as={UnorderedList} minItemWidth={300} expand={false} maxColumns={3}>
            {children}
        </Grid>
    );
};
